import api from '@app/api/api';

const controller = "crfAcronimosProjeto";

export interface CrfAcronimoProjeto {
  id: string;
  sigla: string;
  categoriaId: string;
  grupoId: string;
  nomeCategoria: string;
  nomeGrupo: string;
  disciplina: string;
}

export const getAllCrfAcronimosProjeto = () => api.get<CrfAcronimoProjeto[]>(`${controller}`);
export const getCrfAcronimoProjetoById = (id: string) => api.get<CrfAcronimoProjeto>(`${controller}/${id}`);

export const createCrfAcronimoProjeto = (acronimo: CrfAcronimoProjeto) =>
  api.post<CrfAcronimoProjeto>(`${controller}`, acronimo);

export const updateCrfAcronimoProjeto = (acronimo: CrfAcronimoProjeto) => {
  return api
    .put<boolean>(`${controller}/${acronimo.id}`, acronimo)
    .then(result => true)
    .catch(err => false);
};

export const deleteCrfAcronimoProjeto = (id: string) => api.delete(`${controller}/${id}`);
